import React from 'react'

import IProps from './props'

const AddressInfo = ({ address }: IProps) => (
  <div>
    <div>
      {address.street}
      ,
      {' '}
      {address.number}
    </div>
    <div>
      {address.neighborhood}
      {' '}
      -
      {' '}
      {address.city}
      /
      {address.state}
    </div>
  </div>
)

export default AddressInfo
